import React, { forwardRef, useCallback } from 'react'

import { Box } from 'widgets/Box'
import { Text } from 'widgets/Text'

import { useMaxWidth } from 'hooks/useMaxWidth'

import { InProgressPost, InProgressPostStep } from 'types/post'

import { BaseMultipleStepForm } from './BaseMultipleStepForm'

interface Props {
  initialValues: InProgressPost
  onValuesChange: (values: Partial<InProgressPost>) => void
  saveMultipleSteps: (stepsData: Partial<InProgressPostStep[]>) => void
  deleteStepAtIndex: (stepIndex: number) => void
  paddingOnTop?: boolean
  mediaSize?: 'oneThird' | 'half' | 'twoThird' | 'full'
  showInfoText?: boolean
}

export const PostStepsForm = forwardRef(
  (
    {
      initialValues,
      onValuesChange,
      saveMultipleSteps,
      deleteStepAtIndex,
      paddingOnTop = true,
      mediaSize = 'half',
      showInfoText,
    }: Props,
    ref: any,
  ) => {
    const { width: maxWidth } = useMaxWidth()

    const getChildren = useCallback(
      (mediaSelector: JSX.Element) => (
        <>
          {paddingOnTop && <Box height={maxWidth * 0.15} />}
          <Box justifyContent='center' align='center'>
            {mediaSelector}
          </Box>
        </>
      ),
      [],
    )

    return (
      <>
        <BaseMultipleStepForm<InProgressPost>
          ref={ref}
          allowedFileType='both'
          initialValues={{
            ...initialValues,
          }}
          onValuesChange={onValuesChange}
          submitCopy=''
          size={mediaSize}
          saveMultipleSteps={saveMultipleSteps}
          deleteStepAtIndex={deleteStepAtIndex}
        >
          {getChildren}
        </BaseMultipleStepForm>
        {showInfoText && (
          <Box width='100%'>
            {initialValues.steps.length === 1 && !initialValues.steps[0].file && (
              <Box
                height={1}
                width='100%'
                margin={{ vertical: 'xl' }}
                backgroundColor='greyLight'
              />
            )}
            <Box margin={{ horizontal: 'md' }}>
              <Text fontSize='sm' color='greyDark' align='center'>
                Choose as many steps as you like. We recommend uploading 3-10s exercise clips for
                each step.
              </Text>
            </Box>
            <Box height={1} width='100%' margin={{ vertical: 'xl' }} backgroundColor='greyLight' />
          </Box>
        )}
      </>
    )
  },
)
